
import {mapGetters} from 'vuex';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import mvtCardProperty from '@/common/components/mvtcardproperty/mvt-cardproperty.vue';

export default {
    name: 'searchListonly',
    components: {
        mvtShifter,
        mvtCardProperty
    },
    data() {
        return {
            isSortByRandom: false,
            utmParams: ''
        };
    },
    mounted(){
        $('#body').addClass('bg-color-f');
    },
    beforeUnmount(){
        $('#body').removeClass('bg-color-f');
    },
    computed: {
        ...mapGetters('msp', ['geo', 'msp', 'getListings', 'getIsSearching', ]),
        ...mapGetters('glb', ['glb']),
        lazyloadCount(){
            return this.glb.isMobile ? 3: 8;
        },
    },
    created() {
        const queryObj = this.$route.query;
        if (queryObj) {
            if (queryObj.sortbyrandom) {
                this.isSortByRandom = true;
            }
            let utms = [];
            Object.keys(queryObj).forEach((key) => {
                if (key.indexOf('utm_') > -1) {
                    utms.push(`${key}=${queryObj[key]}`);
                }
            });
            if (utms.length > 0) {
                this.utmParams = `${utms.join('&')}`;
            }
        }
     }
};

